import { ConfigDefaultService } from './../../../modules/shared/services/configuration-default.service';
import { ParseHelper } from './../../../modules/shared/parse.helper';
import { TimeZoneService } from './../../../modules/shared/services/timezone.service';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

// PrimeNg
import { LazyLoadEvent, MessageService } from "primeng/api";

// Components
import { AppMainComponent } from "src/app/app.main.component";

// Models
import { Account } from "../../models/account.model";
import { Channel } from "../../models/configuration/channel.model";
import { ContextMenuItem } from "../../models/contextMenuItem.model";
import { Section } from "../../models/configuration/section.model";
import { Stage } from "../../models/configuration/stage.model";

// Services
import { AccountsHttpService } from "src/app/modules/shared/services/accounts.http.service";
import { AppMainService } from "src/app/app-main.service";
import { StoreService } from "src/app/modules/shared/services/store.service";

// Helpers
import { AccountHelper } from "../../services/accounts.helper";
import { scrollToTop } from '../../../modules/shared/helpers/scroll-to-top.helper';
import { FilterInColumn, GelAllAccountRequestModel } from "../../models/account-request.model";
import { AccountServiceN } from "../../services/account.services";
import { Table } from "primeng/table";
import { TitleCasePipe } from "@angular/common";
import { AccountModuleId} from 'src/app/modules/shared/constants/modules.constant';
import { HttpErrorResponse } from '@angular/common/http';
import { Severity } from 'src/app/inventory/constants/constants';
import * as moment from 'moment';
import { WorkbookReminderInputProps } from 'src/app/misc/workspace/models/workbook-reminder.models';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';

interface UploadEvent {
    originalEvent: Event;
    files: File[];
}

@Component({
    selector: 'app-accounts-listing',
    styleUrls: ['./accounts-listing.component.scss'],
    templateUrl: './accounts-listing.component.html',
})

export class AccountsListingComponent implements OnInit, OnChanges, OnDestroy {
    @Input() isDetailsShowing: boolean;
    @Input() contextMenuItems: ContextMenuItem[] = [];
    @Input() selectedView: string;
    @Input() savedListCols: Section[] = [];
    @Input() listColsAll: Section[] = [];
    @Input() fromGlobalSearch: boolean;
    @Input() rowGroupMetadata: Account[];
    @Input() globalSearchData: any[] = [];
    @Input() isFirst: boolean;
    @Input() pageNumber: number;
    @Input() pageSize: number;
    @Input() totalRecords: number;
    @Input() noAccountFindOrLoadingText: string = 'Loading....';
    @Input() expandedRows: any = [];
    @Input() selectedChannel: Channel;
    @Input() accountTreeViewEnabled: boolean = true;
    @Input() showFloatHeader: boolean = false;

    @Input() selectedActiveStages: Stage[] = [];
    @Input() searchValue: string;
    @Input() selectedFilter: string;
    @Input() selectedColumn: any[];
    @Input() filterInColumns: FilterInColumn[];
    @Input() sortByColumnName: string;
    @Input() isSortByDescending: boolean;
    @Input() first: number = 0;
    @Input() fromUpdateSettings: boolean;
    @Input() selectedGroupByValue: any = null;
    @Input() isActive: boolean = true;
    @Input() selectedStageId: number;
    @Input() stagesCountN;
    @Input() showActionColumn: boolean = false;

    @Output() rowSelect = new EventEmitter();
    @Output() rowUnselect = new EventEmitter();
    @Output() getContextMenuOptions = new EventEmitter();
    @Output() clearFilterOption = new EventEmitter();
    @Output() setSelectedView = new EventEmitter();
    @Output() getAllAccountsWithPagination = new EventEmitter();
    @Output() refreshList = new EventEmitter();

    globalSearchRefresh: boolean;

    /* Table Listing */
    @Input() selectedAccount: Partial<Account>;
    filteredAccount: Partial<Account>;
    tableShowMore: number[] = [15, 30, 50, 100];
    allStages: Partial<Stage>[] = [];
    stages: Stage[] = [];
    actualStages: Stage[] = [];
    selectedRecent = { label: "All Accounts", code: 'allaccounts' };
    hasChildAccounts: boolean;
    accountContacts: any[] = [];
    accountTempAddress: any[];
    primaryContact: any;
    filteredColumns: string[] = [];

    filterMatchModes = [];
    selectedFilterMode: string = '';
    groupAllExpanded: boolean = false;

    /* Subject to unsubscribe */
    private ngUnsubscribe = new Subject<void>();
    @ViewChild('accountsTable') accountsTable: Table | undefined;

    phoneFields: string[] = ['workphone','contactphonemobile', 'contactphonework', 'contactphonehome', 'contactphonecp1', 'contactphonecp2'];
    mergeAccountSequenceNumber: boolean = true;

    displayAttachment = false;
    uploadedFiles: any[] = [];
    documentsList:any[] = [];
    documentPageSize = 5;
    documentPageNumber = 1;
    totalDocumentRecords = 0;
    displayActivitySidebar = false;
    displayTaskSidebar = false;
    accountData;

    //** Task pop up variable */
    showTaskDialog: boolean = false;
    selectedTaskAccount: any;

    //** Event Pop up Variable */
    showEventDialog: boolean = false;
    selectedEventAccount: Account;
    accountModuleId : number = AccountModuleId;
    /** Reminder */
    displayReminder: boolean = false;
    workbookReminderProps: WorkbookReminderInputProps;
    isActionClicked = false;
    //decimal fractiondigits
    maximumFractionDigits: number = 2;

    constructor(
        private app: AppMainComponent,
        private accountsHttpService: AccountsHttpService,
        private appMainService: AppMainService,
        private storeService: StoreService,
        private accountHelper: AccountHelper,
        private messageService: MessageService,
        private accountServiceN: AccountServiceN,
        private timeZoneService: TimeZoneService,
        private configDefaultService: ConfigDefaultService,
        private titlecasePipe: TitleCasePipe,
        private importserialService: ImportserialService,

    ) {
        this.filterMatchModes = [
            {
                name: 'Starts with',
                value: 'starts_with'
            },
            {
                name: 'Contains',
                value: 'contains'
            },
            {
                name: 'Not contains',
                value: 'not_contains'
            },
            {
                name: 'Ends with',
                value: 'ends_with'
            },
            {
                name: 'Equals',
                value: 'equals'
            },
            {
                name: 'Not Equals',
                value: 'not_equals'
            }
        ]
        this.selectedFilterMode = this.filterMatchModes[0];

        this.configDefaultService.getMergeAccountSequenceNumber().then(response=>{
            this.mergeAccountSequenceNumber = response?.enabled||false;
        });
    }

    ngOnInit(): void {
        this.setFractionDigits();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.isFirst?.currentValue) {
            this.first = 0;
        }

        if(changes?.filterInColumns){
            this.filterInColumns = changes?.filterInColumns?.currentValue||null;
            this.filteredColumns = (this.filterInColumns ?? []).map((sf => sf.name));
        }

        if (changes?.fromUpdateSettings?.currentValue) {
            const currentSettingsValue = changes?.fromUpdateSettings?.currentValue;
            if (currentSettingsValue == true){
                this.removeColumnFiltering();
            }
        }

        if(changes?.selectedGroupByValue?.currentValue){
            this.selectedGroupByValue = changes?.selectedGroupByValue?.currentValue;
        }

        if(changes?.rowGroupMetadata?.currentValue){
            this.groupAllExpanded = false;
        }

        if(changes?.selectedAccount && changes?.selectedAccount?.currentValue){
            this.selectedAccount = changes?.selectedAccount?.currentValue;
        }

        this.savedListCols = this.savedListCols.filter(function( obj ) {
            return obj.name !== 'Action';
        });
    }

    removeColumnFiltering(): void {
       Object.keys(this.accountsTable?.filters)?.map((filter) => {
            this.accountsTable.filters[filter]['value'] = '';
        });
            this.accountsTable.sortField = null;
    }

    populateContextMenu(): void {
        this.getContextMenuOptions.emit(this.selectedAccount);
    }

    // Fired when there is any change on Table
    onLazyLoad(event: LazyLoadEvent) {
        this.getAllAccountsWithPagination.emit(event);
    }
    onPageChange(event){
        let obj = {
            filters:{},
            first:event.first,
            globalFilter:null,
            multiSortMeta:null,
            rows:event.rows,
            sortField:null,
            sortOrder:1
        }
        this.getAllAccountsWithPagination.emit(obj);
    }

    // Fired to refresh the listing
    onRefreshList(): void {
        this.refreshList.emit({});
    }

    // Get Account Details from API
    async getAccountDetailsById(id, isRowSelected = false, hideSpinner: boolean = false): Promise<void> {
        this.hasChildAccounts = this.selectedAccount?.hasChildAccounts;
        if(!hideSpinner) {
            this.appMainService.isShowSpinner('getAccountDetailsById');
        }

        this.accountsHttpService.getAccountDetails(id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(resp => {
                this.accountData = resp;
                if(this.selectedGroupByValue){
                    this.expandSelectedRowGroup();
                }
                this.setSelectedAccountDetails(resp, this.selectedActiveStages);
                isRowSelected && this.rowSelect.emit({ data: this.selectedAccount });
                scrollToTop();
                this.appMainService.isHideSpinner('getAccountDetailsById');
            }, () => {
                this.appMainService.isHideSpinner('getAccountDetailsById');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error!',
                    detail: 'Error occurring when fetching accounts details. Please try after sometimes.'
                });
            });
    }

    // Set Details of the Selected Account
    setSelectedAccountDetails(account, stages): void {
        let stage = stages?.filter(elem => elem.id === account.categoryId);

        const data = {
            ...account,
            contactName: account.accountContacts?.length && account.accountContacts[0] && account.accountContacts[0].contact ?
                account.accountContacts[0].contact.firstName + ' ' + account.accountContacts[0].contact.lastName : null,
            accountStatus: account.accountStatus?.name || "",
            accountCategory: stage?.length ? stage[0].name : null,
            accountTypesNames: account.accountTypes?.length ? this.accountHelper.processAccountNames(account.accountTypes) : null,
            stageId: stage?.length ? stage[0].id : null,
            statusName: account.status ? account.status.name : null
        };

        let datas = [];
        datas.push(data);

        let responseData: any = this.accountHelper.processAccountDetailsData(data);

        this.filteredAccount = responseData;
        this.selectedAccount = responseData;

        this.storeService.setAccountData(this.selectedAccount);
        this.storeService.setActivityLogList([]);
        this.storeService.setContactList([]);
        this.storeService.setTaskList([]);
        this.storeService.setInventoryDetails(null);
        this.storeService.setPriceTierByAccount(null);

        this.accountContacts = this.selectedAccount.accountContacts;

        for (let el of this.accountContacts) {
            if (!el.contactName) {
                el.contactName = el.contact.firstName + ' ' + el.contact.lastName;
            }
        }

        this.accountTempAddress = this.selectedAccount.accountAddresses;
        this.primaryContact = account.accountContact?.length ? account.accountContact.filter(el => el.isPrimaryContact)[0] : null;
    }

    getExpandedRows(list, parentId, parent: any, rowColor: string): void {
        list?.forEach(element => {
            element.viewDetails = false;
            element.childLevel = (parent?.childLevel||0)+1;
            element.rowColor = rowColor;
            element.mainCustomerId = parentId;
            if (element.hasChildAccounts) {
                this.expandedRows[element.id] = false;
            }
        });
    }

    onExpandRow(parentId, parent, expanded, rowColor: string = "") {
        parent.viewDetails = !expanded;
        this.expandedRows[parentId] = !expanded;

        if (!(parent.childAccount && parent.childAccount.length > 0)) {

            const requestModel: GelAllAccountRequestModel = {
                channelId: this.selectedChannel?.id,
                stageId: this.selectedStageId,
                isActive: this.isActive,
                globalSearchValue: parentId>0 ? '' : this.searchValue.trim() || '',
                selectableColumns: this.selectedColumn,
                filter: this.selectedFilter,
                pageSize: 0,
                pageNumber: 0,
                sortByColumn: this.sortByColumnName || null,
                isSortByDescending: this.isSortByDescending,
                filterInColumns: parentId>0 ? [] : this.filterInColumns,
                parentAccountId: parentId
            }

            this.appMainService.isShowSpinner('getAccountByParentId');
            this.accountServiceN.getAccountsList(requestModel)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe({
                    next: (response) => {
                        if (response) {
                            parent.childAccount = response?.list||[];
                            parent.viewDetails = true;
                            this.expandedRows[parentId] = true;
                            this.getExpandedRows(parent.childAccount, parentId, parent, rowColor);
                        }
                        this.noAccountFindOrLoadingText = '';
                        this.appMainService.isHideSpinner('getAccountByParentId');
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('getAccountByParentId');
                        this.noAccountFindOrLoadingText = 'No accounts found.';
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error!',
                            detail: 'Error occurring when loading accounts. Please try after sometime.'
                        });
                    },
                    complete: () => {

                    }
                })

        }
    }

    onListPageChange($event,rowData: any){
        const requestModel: GelAllAccountRequestModel = {
            channelId: this.selectedChannel?.id,
            stageId: this.selectedStageId,
            isActive: this.isActive,
            globalSearchValue: this.searchValue.trim() || '',
            selectableColumns: this.selectedColumn,
            filter: this.selectedFilter,
            pageSize: 15,
            pageNumber: ($event?.page+1),
            sortByColumn: this.sortByColumnName || null,
            isSortByDescending: this.isSortByDescending,
            filterInColumns: ParseHelper.DeepCopy(this.filterInColumns||[]),
            includeChildAccounts: true
        }
        let groupValue = rowData.groupByValue===null ? [""] : [rowData.groupByValue];
        let operator = "IsEqualTo";
        if(!rowData.groupByValue){
            operator = "NoValue";
        }else if(this.selectedGroupByValue?.fieldDataType=="DateTime"){
            operator = "Between";
            groupValue = [];
            let dateRangeFrom = new Date(rowData.groupByValue);
            let dateRangeTo = new Date(rowData.groupByValue);

            dateRangeFrom = this.timeZoneService._getUTCDateTimeWithZone(dateRangeFrom, (this.selectedGroupByValue?.isDateWithTime||false), true, false);
            dateRangeTo = this.timeZoneService._getUTCDateTimeWithZone(dateRangeTo, (this.selectedGroupByValue?.isDateWithTime||false), true, false);
            dateRangeTo.setDate(dateRangeTo.getDate() + 1);
            dateRangeTo = new Date(dateRangeTo.getTime() - 1000);
            groupValue.push(this.timeZoneService._getUTCDateTimeString(dateRangeFrom),this.timeZoneService._getUTCDateTimeString(dateRangeTo));
        }
        const groupFilterData: FilterInColumn = {
            name: this.selectedGroupByValue?.columnName,
            value: null,
            operator: operator,
            operationType: "AND",
            values: groupValue
        }

        const groupFilterIndex = requestModel.filterInColumns.findIndex(filter=> filter.name==this.selectedGroupByValue?.columnName);

        if(groupFilterIndex>=0){
            requestModel.filterInColumns[groupFilterIndex] = groupFilterData;
        }else{
            requestModel.filterInColumns.push(groupFilterData);
        }

        this.appMainService.isShowSpinner('getAccountByParentId');
        this.accountServiceN.getAccountsListWithFilters(requestModel)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
            next: (response) => {
                if (response) {
                    rowData.list = response.list;
                }
                this.appMainService.isHideSpinner('getAccountByParentId');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getAccountByParentId');
                this.noAccountFindOrLoadingText = 'No accounts found.';
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error!',
                    detail: 'Error occurring when loading accounts. Please try after sometime.'
                });
            },
            complete: () => {

            }
        });
    }

    // Unselect a row from the Listing Table
    onRowUnselect() {
        this.rowUnselect.emit();
    }

    onAllGroupExpand(){
        this.groupAllExpanded = !this.groupAllExpanded;
        this.rowGroupMetadata.map(rowData=>{
            this.expandedRows[rowData.id] = this.groupAllExpanded;
            rowData['expanded'] = this.groupAllExpanded;
        })
    }

    onGroupExpand(rowData: any, expanded: boolean){
        rowData['expanded'] = !expanded;
        this.expandedRows[rowData.id] = rowData['expanded'];
    }

    expandSelectedRowGroup(){
        const groupByValue = this.selectedAccount[this.selectedGroupByValue?.columnName];
        this.groupAllExpanded = false;
        this.rowGroupMetadata.map((rowData: any)=>{
            rowData['expanded'] = (rowData.groupByValue==groupByValue) as boolean;
        })
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    uploadAttach(event,data){
        event.stopPropagation();
        this.selectedAccount = data;
        // this.getAccountDetailsById(this.selectedAccount.id, false, true);
        this.displayAttachment = true;
        this.displayReminder = false;
        this.displayActivitySidebar = false;
        this.displayTaskSidebar = false;
        this.isActionClicked = true;
    }

    onUpload(event:UploadEvent) {
        for(let file of event.files) {
            this.uploadedFiles.push(file);
        }

        this.messageService.add({severity: 'info', summary: 'File Uploaded', detail: ''});
    }

    getAllDocumentsWithPagination(event?: LazyLoadEvent) {
        if (event) {
            this.documentPageSize = event.rows;
            this.documentPageNumber = (event.first / event.rows) + 1;
        }
        else {
            this.documentPageSize = 5;
            this.documentPageNumber = 1;
        }
        this.getAccountDocumentList();
    }

    getAccountDocumentList(){
        this.appMainService.isShowSpinner('getAccountDocumentList');
          let  requesBody:{
            AccountId:number;
            AccountName:string;
            PageNumber:number;
            PageSize:number;
            LeadId?:number;
          } = {
                AccountId: this.selectedAccount?.id,
                AccountName: this.selectedAccount?.businessName,
                PageNumber: this.documentPageNumber,
                PageSize: this.documentPageSize,
                LeadId: this.selectedAccount?.leadId
          }
          this.accountServiceN.getAccountDocumentList(requesBody).subscribe({
            next:(data)=>{
                this.documentsList = data?.body||[];
                const headers = data?.headers ? JSON.parse(data.headers.get('x-pagination')) : null;
                this.totalDocumentRecords = headers?.TotalCount||0;
                this.appMainService.isHideSpinner('getAccountDocumentList');
            },
            error:(error:HttpErrorResponse)=>{
                this.messageService.add({
                  severity: Severity.Error,
                  summary: this.titlecasePipe.transform(Severity.Error),
                  detail: "Error occurred while saving data...",
              });
              this.appMainService.isHideSpinner('getAccountDocumentList');
              }
        })
      }

    uploadDoc(event, data) {
        event.stopPropagation();
    }

    openActivity(event, data) {
        event.stopPropagation();
        this.selectedAccount = data;
        this.displayActivitySidebar = true;
        // this.getAccountDetailsById(this.selectedAccount.id, false, true);
        this.displayAttachment = false;
        this.displayReminder = false;
        this.displayTaskSidebar = false;
        this.isActionClicked = true;
    }

    onActivityDialogClose(){
        this.displayActivitySidebar = false;
        this.selectedAccount = null;
        this.accountData = null;
        this.isActionClicked = false;
    }

    onAttachmentDialogClose(){
        this.selectedAccount = null;
        this.accountData = null;
        this.displayAttachment = false;
        this.isActionClicked = false;
    }

    openTaskSidebar(event,selectedTaskAccount){
        event.stopPropagation();
        this.selectedTaskAccount = selectedTaskAccount;
        this.selectedTaskAccount.channelId= this.selectedChannel?.id,
        this.displayTaskSidebar = true;
        this.displayActivitySidebar = false;
        this.displayAttachment = false;
        this.displayReminder = false;
        this.isActionClicked = true;
    }

    openTaskPopup(event, selectedTaskAccount){
        event.stopPropagation();
        this.selectedTaskAccount = selectedTaskAccount;
        this.selectedTaskAccount.channelId= this.selectedChannel?.id,
        this.showTaskDialog = true;
    }

    onTaskDialogClose(){
        this.displayTaskSidebar = false;
        this.showTaskDialog = false;
        this.selectedTaskAccount = null;
        this.isActionClicked = false;
    }

    openEventPopup(event, selectedEventAccount){
        event.stopPropagation();
        this.selectedEventAccount = selectedEventAccount;
        this.showEventDialog = true;
    }

    onEventDialogClose(){
        this.showEventDialog = false;
        this.selectedEventAccount = null;
        this.isActionClicked = false;
    }

    getDateClass(isoDate: string): string {
        if (!isoDate) {
            return ''; // Return default class if no date is provided
        }
        const currentDateTimeUTC = moment(this.app._showDateTimeWithZone(new Date())).utc();
        const checkDateUTC = moment(this.app._showDateTimeWithZone(isoDate)).utc();

        if (checkDateUTC.isBefore(currentDateTimeUTC)) {
            return 'past-date'; // Overdue
        }

        if (checkDateUTC.isSame(currentDateTimeUTC, 'day')) {
            return 'current-date'; // Today's task
        }
        return 'upcoming-date'; // Upcoming task
    }


      getDateTooltip(dateClass: string): string {
        switch (dateClass) {
          case 'past-date':
            return 'Overdue Task';
          case 'upcoming-date':
            return 'Due Task';
          case 'current-date':
            return 'Today\'s Task';
          default:
            return '';
        }
      }

      getEventTooltip(dateClass: string): string {
        switch (dateClass) {
          case 'past-date':
            return 'Past Event';
          case 'upcoming-date':
            return 'Upcoming Event';
          case 'current-date':
            return 'Today\'s Event';
          default:
            return '';
        }
      }


  //#region Account Reminder
  openReminderModal(event, selectedAccount) {
    event.stopPropagation();
    this.workbookReminderProps = {
      objectId: this.accountModuleId,
      objectRecordId: selectedAccount?.id,
      moduleData : selectedAccount
    }
    this.displayTaskSidebar = false;
    this.displayActivitySidebar = false;
    this.displayAttachment = false;
    this.displayReminder = true;
    this.isActionClicked = true;
  }

  onHideReminderModal() {
    this.displayReminder = false;
    this.selectedAccount = null;
    this.workbookReminderProps = null;
    this.isActionClicked = false;
  }

  
  setFractionDigits(){
    this.importserialService.getDecimalValue().subscribe(value=>{
        this.maximumFractionDigits = value||this.maximumFractionDigits;
    });
}
  //#end Account

  handleActivtyStatus(selectedAccountId: number){
    this.selectedAccount.NoOfUnreadLogs = 0;
  }
}

